import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { BeneficiaryGroup } from '@shared/beneficiary/beneficiary-group';
import { Moneybar } from '@shared/funding/moneybar';
import { Moment } from 'moment';
import { Observable } from 'rxjs';

import { TotalFunding } from './total-funding.model';

@Injectable({
  providedIn: 'root',
})
export class FundingApi {
  private readonly endpoint: string;

  constructor(private httpClient: HttpClient) {
    this.endpoint = `${environment.endpointUrl}/funding`;
  }

  getCurrentFunding(): Observable<Moneybar> {
    return this.httpClient.get<Moneybar>(`${this.endpoint}/current`);
  }

  getCurrentFundingAt(givenDate: Moment): Observable<Moneybar> {
    return this.httpClient.get<Moneybar>(`${this.endpoint}/current/atdate?date=${givenDate.format('DD-MM-yyyy')}`);
  }

  getCanidateGroupsForMoneybar(): Observable<BeneficiaryGroup[]> {
    return this.httpClient.get<BeneficiaryGroup[]>(`${this.endpoint}/groups`);
  }

  getFundingForGroup(beneficiaryGroupUuid: string): Observable<Moneybar> {
    return this.httpClient.get<Moneybar>(`${this.endpoint}/group/${beneficiaryGroupUuid}`);
  }

  getFundingForGroupAt(beneficiaryGroupUuid: string, givenDate: Moment): Observable<Moneybar> {
    return this.httpClient.get<Moneybar>(
      `${this.endpoint}/group/${beneficiaryGroupUuid}/atdate?date=${givenDate.format('DD-MM-yyyy')}`,
    );
  }

  getTotalFunding(): Observable<TotalFunding> {
    return this.httpClient.get<TotalFunding>(`${this.endpoint}/totals`);
  }
}
